import AppImage, { IAppImage } from "components/AppImage/AppImage";
import { useCountry } from "hooks";
import { useEffect, useState } from "react";

export const INTERNAL_IMAGES = {
  login: "login.png",
  "choose-subscription": "choose-subscription.png",
} as const;

export type ImageId = keyof typeof INTERNAL_IMAGES;

const BASE_URL = process.env.NEXT_PUBLIC_INTERNAL_IMAGE_DOMAIN;

type InternalImageProps = Omit<IAppImage, "src"> & {
  imageId: ImageId;
};

const InternalImage = ({
  imageId,
  isLCP = true,
  ...props
}: InternalImageProps) => {
  const country = useCountry();
  const [hidden, setHidden] = useState(false);

  const src = `${BASE_URL}/${country.toLowerCase()}/${
    INTERNAL_IMAGES[imageId]
  }`;

  useEffect(() => {
    setHidden(false);
  }, [imageId, country]);

  if (hidden) {
    return null;
  }

  return (
    <AppImage
      src={src}
      isLCP={isLCP}
      onError={() => setHidden(true)}
      {...props}
    />
  );
};

export default InternalImage;
